import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="bg-gradient-to-br from-gray-900 to-black text-white py-12 lg:py-20">
      <div className="max-w-md lg:max-w-7xl mx-auto px-4">
        {/* Desktop: 4 Columns Layout */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 lg:gap-12 mb-8 lg:mb-12">
          
          {/* Column 1: Logo & Description */}
          <div className="text-center lg:text-left lg:col-span-1">
            <div className="flex items-center justify-center lg:justify-start gap-2 mb-4">
              <div className="w-8 h-8 lg:w-10 lg:h-10 bg-gradient-to-br from-red-500 to-red-600 rounded-full flex items-center justify-center shadow-md">
                <i className="ri-truck-fill text-sm lg:text-base text-white"></i>
              </div>
              <div className="flex flex-col leading-none">
                <span className="text-base lg:text-lg font-extrabold tracking-tight text-white">
                  Transporteur<span className="text-red-500"> express</span>
                </span>
                <span className="text-[9px] lg:text-[10px] font-medium tracking-widest uppercase text-gray-500">
                  Île-de-France
                </span>
              </div>
            </div>
            <p className="text-sm lg:text-base text-gray-400 max-w-xs mx-auto lg:mx-0">
              Votre coursier express de confiance à Paris et en Île-de-France
            </p>
          </div>

          {/* Column 2: Services */}
          <div className="text-center lg:text-left">
            <h4 className="text-sm lg:text-base font-bold mb-4 lg:mb-6">Services</h4>
            <ul className="space-y-2 lg:space-y-3 text-xs lg:text-sm text-gray-400">
              <li><a href="#services" className="hover:text-yellow-500 transition-colors cursor-pointer">Express</a></li>
              <li><a href="#services" className="hover:text-yellow-500 transition-colors cursor-pointer">Urgent</a></li>
              <li><a href="#services" className="hover:text-yellow-500 transition-colors cursor-pointer">Volumineux</a></li>
              <li><a href="#services" className="hover:text-yellow-500 transition-colors cursor-pointer">Programmé</a></li>
            </ul>
          </div>

          {/* Column 3: Links */}
          <div className="text-center lg:text-left">
            <h4 className="text-sm lg:text-base font-bold mb-4 lg:mb-6">Liens</h4>
            <ul className="space-y-2 lg:space-y-3 text-xs lg:text-sm text-gray-400">
              <li><a href="#services" className="hover:text-yellow-500 transition-colors cursor-pointer">Services</a></li>
              <li><a href="#zones" className="hover:text-yellow-500 transition-colors cursor-pointer">Zones de service</a></li>
              <li><button onClick={() => navigate('/avis-google')} className="hover:text-yellow-500 transition-colors cursor-pointer">Avis Google</button></li>
              <li><button onClick={() => navigate('/temoignages-clients')} className="hover:text-yellow-500 transition-colors cursor-pointer">Témoignages</button></li>
              <li><button onClick={() => navigate('/laisser-un-avis')} className="hover:text-yellow-500 transition-colors cursor-pointer">Laisser un avis</button></li>
              <li><button onClick={() => navigate('/a-propos')} className="hover:text-yellow-500 transition-colors cursor-pointer">À propos</button></li>
              <li><button onClick={() => navigate('/blog')} className="hover:text-yellow-500 transition-colors cursor-pointer">Blog</button></li>
              <li><a href="#faq" className="hover:text-yellow-500 transition-colors cursor-pointer">FAQ</a></li>
              <li><a href="#tracking" className="hover:text-yellow-500 transition-colors cursor-pointer">Suivi</a></li>
              <li><a href="#contact" className="hover:text-yellow-500 transition-colors cursor-pointer">Contact</a></li>
            </ul>
          </div>

          {/* Column 4: Zones Locales */}
          <div className="text-center lg:text-left">
            <h4 className="text-sm lg:text-base font-bold mb-4 lg:mb-6">Nos Zones</h4>
            <ul className="space-y-2 lg:space-y-3 text-xs lg:text-sm text-gray-400">
              <li><button onClick={() => navigate('/transporteur-express-nanterre')} className="hover:text-yellow-500 transition-colors cursor-pointer">Nanterre (92)</button></li>
              <li><button onClick={() => navigate('/transporteur-palettes-rungis')} className="hover:text-yellow-500 transition-colors cursor-pointer">Rungis (94)</button></li>
              <li><button onClick={() => navigate('/livraison-urgente-evenementiel-villepinte')} className="hover:text-yellow-500 transition-colors cursor-pointer">Villepinte (93)</button></li>
              <li><button onClick={() => navigate('/transport-paris')} className="hover:text-yellow-500 transition-colors cursor-pointer">Paris (75)</button></li>
              <li><button onClick={() => navigate('/coursier-paris')} className="hover:text-yellow-500 transition-colors cursor-pointer">Coursier Paris</button></li>
            </ul>
          </div>
        </div>

        {/* Section Départements - Full Width */}
        <div className="border-t border-gray-800 pt-8 lg:pt-10 mb-8 lg:mb-10">
          <h4 className="text-sm lg:text-base font-bold mb-4 lg:mb-6 text-center">Nous intervenons dans toute l'Île-de-France</h4>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 text-xs lg:text-sm text-gray-400 text-center">
            <div>
              <strong className="text-white">Paris (75)</strong>
              <p className="mt-1">Tous arrondissements</p>
            </div>
            <div>
              <strong className="text-white">Hauts-de-Seine (92)</strong>
              <p className="mt-1">Nanterre, Courbevoie, La Défense</p>
            </div>
            <div>
              <strong className="text-white">Seine-Saint-Denis (93)</strong>
              <p className="mt-1">Villepinte, Le Bourget, Aulnay</p>
            </div>
            <div>
              <strong className="text-white">Val-de-Marne (94)</strong>
              <p className="mt-1">Rungis, Créteil, Orly</p>
            </div>
            <div>
              <strong className="text-white">Essonne (91)</strong>
              <p className="mt-1">Évry, Corbeil-Essonnes</p>
            </div>
            <div>
              <strong className="text-white">Yvelines (78)</strong>
              <p className="mt-1">Versailles, Saint-Quentin</p>
            </div>
            <div>
              <strong className="text-white">Val-d'Oise (95)</strong>
              <p className="mt-1">Cergy, Argenteuil</p>
            </div>
            <div>
              <strong className="text-white">Seine-et-Marne (77)</strong>
              <p className="mt-1">Meaux, Melun</p>
            </div>
          </div>
        </div>

        {/* Social & Contact - Full Width */}
        <div className="text-center border-t border-gray-800 pt-8 lg:pt-10 mb-8">
          <h4 className="text-sm lg:text-base font-bold mb-4 lg:mb-6">Suivez-nous</h4>
          <div className="flex justify-center space-x-3 lg:space-x-4 mb-6">
            <a href="#" className="w-10 h-10 lg:w-12 lg:h-12 bg-white/10 rounded-lg flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
              <i className="ri-facebook-fill text-lg lg:text-xl"></i>
            </a>
            <a href="#" className="w-10 h-10 lg:w-12 lg:h-12 bg-white/10 rounded-lg flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
              <i className="ri-instagram-line text-lg lg:text-xl"></i>
            </a>
            <a href="#" className="w-10 h-10 lg:w-12 lg:h-12 bg-white/10 rounded-lg flex items-center justify-center hover:bg-red-600 transition-colors cursor-pointer">
              <i className="ri-linkedin-fill text-lg lg:text-xl"></i>
            </a>
          </div>
          <p className="text-xs lg:text-sm text-gray-400">
            <i className="ri-phone-line mr-2"></i>
            06 32 41 02 46
          </p>
        </div>

        {/* Copyright - Full Width */}
        <div className="text-center pt-8 lg:pt-10 border-t border-gray-800">
          <p className="text-xs lg:text-sm text-gray-500 mb-2">
            © 2026 Transporteur Express IDF. Tous droits réservés.
          </p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs lg:text-sm text-gray-600 hover:text-yellow-500 transition-colors cursor-pointer"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}